import { RootState } from '../../bll/store/store';

const adminDrawsPagesCountSelector = (state: RootState) => state.adminDraws.adminDraws.pagesCount;
const adminDrawsItemsSelector = (state: RootState) => state.adminDraws.adminDraws.items;
const isAdminDrawsFetchingSelector = (state: RootState) => state.adminDraws.isFetching;

export { adminDrawsPagesCountSelector, adminDrawsItemsSelector, isAdminDrawsFetchingSelector };
